module.exports = __webpack_public_path__ + "static/media/half_moon_hat.4b601cb2.png";